requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xFormSF', {
      show: false,
      loading: false,
      cached: [],
      selected: false,

      load(url, element, id, formName) {
        // Preload function - can be used to cache or prepare form data
        // Currently a placeholder to prevent errors
        if (!this.cached.includes(id)) {
          this.cached.push(id);
        }
      },

      open(name) {
        const existingScript = document.querySelector('script[src="https://js.hsforms.net/forms/embed/49511833.js"]');
        if (existingScript) {
            existingScript.remove();
        }
    
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/embed/49511833.js';
        script.defer = true;
    
        document.body.appendChild(script);
        this.show = name;
        Alpine.store('xPopup').open = true; 
      },

      close() {
        setTimeout(() => {
          this.show = false;
          if (Alpine.store('xQuickView').show == false) {
            Alpine.store('xPopup').open = false;
          }
        }, 0);
      },

      removeFocusQuickView() {
        if (!this.selected) {
          const elementActive = document.getElementById("button_quickview");
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },
    });
  });
});